var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4254.17,-1.19141 H 0.0546875 V 4253.19 H 4254.17 V -1.19141",
    style: {
      fill: "#00acd9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 576.648,3388.19 c 2.532,48.04 22.77,78.41 68.313,78.41 49.312,0 68.316,-30.37 68.316,-86.05 v -149.3 c 0,-54.37 -20.191,-86.03 -69.554,-86.03 -48.121,0 -67.075,32.9 -67.075,86.03 z m 67.075,-360.64 c 153.047,0 212.527,83.55 212.527,216.41 v 126.52 c 0,140.42 -55.664,211.26 -159.449,211.26 -60.723,0 -97.383,-27.88 -118.91,-69.6 h -1.243 v 184.72 c 0,51.92 16.473,88.57 68.313,88.57 51.84,0 67.074,-30.41 67.074,-83.51 V 3645 h 131.563 v 45.54 c 0,126.55 -41.774,215.05 -201.164,215.05 -151.809,0 -208.758,-97.38 -208.758,-231.47 V 3256.6 c 0,-132.87 58.187,-229.05 210.047,-229.05",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1218.5,3613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.55,12.72 27.55,31.8 v 13.78 c 0,20.66 -8.48,33.38 -27.02,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.12 v 31.27 c 0,20.67 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.27 v -17.48 c 0,-49.28 -26.5,-84.26 -87.97,-84.26 -61.48,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1481.9,3650.32 h 48.22 l -23.85,144.15 h -0.52 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1800.94,3895.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.42 V 3618 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1893.17,3698.02 v -112.35 h 26.5 c 20.14,0 29.68,10.07 29.68,29.15 v 54.05 c 0,19.08 -9.01,29.15 -30.21,29.15 z m 0,46.1 h 21.2 c 19.61,0 28.62,10.07 28.62,29.15 v 43.99 c 0,19.6 -9.01,29.14 -29.15,29.14 h -20.67 z m -60.41,151.56 h 87.44 c 60.42,0 80.55,-28.08 80.55,-78.96 v -36.56 c 0,-30.21 -11.13,-49.28 -36.03,-57.23 30.2,-6.89 45.04,-27.03 45.04,-59.89 v -47.69 c 0,-50.88 -22.79,-78.96 -83.2,-78.96 h -93.8 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2037.34,3895.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2271.59,3846.4 v -111.81 h 20.13 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2412.57,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2580.58,3613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.08,0 27.56,12.72 27.56,31.8 v 13.78 c 0,20.66 -8.48,33.38 -27.03,50.87 l -35.5,35.51 c -34.45,33.91 -50.35,54.58 -50.35,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.14,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.27 v -17.48 c 0,-49.28 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2966.41,3758.43 -33.92,-222.04 h -56.7 l -48.23,359.29 h 58.29 l 28.09,-227.87 h 0.53 l 30.21,227.87 h 49.28 l 33.39,-227.87 h 0.53 l 27.55,227.87 h 50.88 l -46.64,-359.29 h -57.23 l -35.51,222.04 h -0.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3174.7,3650.32 h 48.22 l -23.84,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 L 3304,3536.39 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3317.81,3613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.08,0 27.56,12.72 27.56,31.8 v 13.78 c 0,20.66 -8.48,33.38 -27.03,50.87 l -35.5,35.51 c -34.45,33.91 -50.35,54.58 -50.35,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.14,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.75,-53.52 48.75,-93.27 v -17.48 c 0,-49.28 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3514.44,3613.76 v 48.22 h 56.18 v -49.28 c 0,-20.14 9,-31.8 29.67,-31.8 19.08,0 27.56,12.72 27.56,31.8 v 13.78 c 0,20.66 -8.48,33.38 -27.02,50.87 l -35.51,35.51 c -34.45,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.96,78.96 84.79,78.96 60.41,0 84.25,-29.67 84.25,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.14,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.75,-53.52 48.75,-93.27 v -17.48 c 0,-49.28 -26.49,-84.26 -87.96,-84.26 -61.48,0 -85.33,34.44 -85.33,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3716.9,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 H 3716.9 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3951.15,3846.4 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1397.08,3395.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 3118 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1479.78,3262.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1721.45,3085.67 c 24.91,0 34.45,14.84 34.45,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.45,36.03 h -25.43 v -260.73 z m 94.86,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.44,-96.45 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1897.95,3113.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.08,0 27.56,12.72 27.56,31.8 v 13.77 c 0,20.67 -8.48,33.39 -27.03,50.88 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.11 v 31.27 c 0,20.67 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.85,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2161.35,3150.32 h 48.23 l -23.85,144.15 h -0.53 z m -75.78,-113.93 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2363.81,3262.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2519.63,3395.68 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2605.49,3395.68 h 160.57 v -49.28 h -49.81 v -310.01 h -60.95 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2864.12,3453.98 h 51.4 v -45.58 h -51.4 z m -32.86,-303.66 h 48.22 l -23.85,144.15 h -0.52 z m -31.27,303.66 h 51.41 v -45.58 h -51.41 z m -44.51,-417.59 67.83,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3043.25,3346.4 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.94,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.75,-163.22 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3180.53,3248.89 h 84.79 v -48.75 h -84.79 v 48.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1221.67,2895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1395.51,2895.68 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1539.13,2762.14 v -225.75 h -50.87 v 359.29 h 59.35 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1755.37,2846.4 v -111.82 h 20.13 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1896.35,2895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1989.1,2629.13 v 173.81 c 0,56.18 26.5,96.98 90.09,96.98 66.77,0 85.32,-37.09 85.32,-90.09 v -42.39 h -55.12 v 47.16 c 0,22.26 -7.42,34.98 -29.14,34.98 -21.73,0 -30.74,-15.37 -30.74,-37.09 v -192.91 c 0,-21.72 9.01,-37.09 30.74,-37.09 21.72,0 29.14,13.78 29.14,34.98 v 66.24 h 55.12 v -62 c 0,-51.41 -21.2,-89.56 -85.32,-89.56 -63.59,0 -90.09,41.33 -90.09,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2313.44,2694.84 h -58.29 v -158.45 h -60.41 v 359.29 h 60.41 v -152.09 h 58.29 v 152.09 h 60.94 v -359.29 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2399.31,2895.68 h 160.57 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2760.75,2895.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.41 V 2618 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2843.44,2762.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3090.41,2728.22 h 85.85 v -191.83 h -43.46 v 39.21 c -7.95,-27.03 -24.9,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.98 v 173.81 c 0,56.18 27.02,96.98 90.62,96.98 66.77,0 86.38,-37.09 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.27,-15.37 -31.27,-37.09 v -192.91 c 0,-21.72 9.01,-37.09 29.68,-37.09 19.61,0 29.67,11.13 29.67,34.45 v 63.59 h -28.61 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3208.08,2895.68 h 144.14 v -49.28 h -83.73 v -102.81 h 59.88 v -48.75 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3432.78,2762.14 v -225.75 h -50.87 v 359.29 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2684.09,1976.43 c -36.66,16.15 -83.14,10.33 -127.77,-7.75 -167.88,-68.04 -282.12,-92.51 -458.68,-37.22 -111.18,34.8 -215.22,107.69 -338.19,63.3 -81.61,-29.35 -157.65,-57.36 -249.91,-56.64 l -53.3,273.22 H 2722.4 Z M 2254.92,1165.1 c 0,0 -61.46,-63.16 -161.44,-56.32 -100.21,-6.84 -161.61,56.32 -161.61,56.32 -101.36,101.26 -65.2,227.24 -29.92,292.34 21.8,40.78 177.52,274.64 190.92,294.54 v 1.57 c 0,0 0.22,-0.3 0.61,-0.76 l 0.54,0.76 v -1.57 c 13.04,-19.9 169.01,-253.76 190.8,-294.54 35.32,-65.1 71.38,-191.08 -29.9,-292.34 z m 522.88,1100.56 c -3.17,3.44 -7.42,5.36 -12.24,5.36 h -1352.9 c -4.69,0 -8.99,-1.92 -12.16,-5.36 -2.96,-3.78 -4.14,-8.44 -3.39,-12.79 l 227.3,-1374.729 c 1.24,-7.602 7.9,-13.25 15.59,-13.25 h 278.97 l 19.08,-223.911 -117.39,-0.128 273.15,-273.141 273.81,273.758 -117.36,-0.117 19.05,223.539 h 283.88 c 7.84,0 14.38,5.648 15.53,13.488 l 212.66,1374.491 c 0.72,4.71 -0.66,9.22 -3.58,12.79",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe06);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-06.d94e369a609975c08f01212f8412404b.svg";
export { ForwardRef as ReactComponent };